import script from "./SingleProductTableWrapper.vue?vue&type=script&setup=true&lang=js"
export * from "./SingleProductTableWrapper.vue?vue&type=script&setup=true&lang=js"

import "./SingleProductTableWrapper.vue?vue&type=style&index=0&id=cc994cc6&lang=scss&scoped=true"

import exportComponent from "/app/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-cc994cc6"]])

export default __exports__